/* sts-cart-fx.js — the cart on phones (prototype v6.1, handoff §6). Loaded
   from snippets/sts-bottom-nav.liquid, so on every page that has the bottom
   menu. Everything here is phone-only (the menu's own 860px breakpoint);
   desktop keeps the LlamaCart drawer exactly as it is.

   1. Cart (bottom menu or header bag) opens the cart PAGE. Tapping Cart again
      on the cart page returns to the page the shopper came from, at the same
      scroll position; with none stored (they came from checkout, say), home.
   2. LlamaCart's drawer does not slide in on a phone: its request to open
      (`lcu:cart:toggle`, sent after every add) is stopped before the app
      hears it, the way sections/sts-main-cart.liquid already stops it on
      /cart. The app itself, its cart logic and its Skin Type Cash reward
      auto-add are untouched; a close still goes through.
   3. Add-to-cart feedback: a 16px dot in the type's deep colour arcs from the
      tap to the menu's Cart icon (~0.6s); on landing the icon bounces and the
      badge pops to the new total. The badge keeps the old number until then.
      prefers-reduced-motion: no dot, the badge simply updates. The badge
      itself is painted by assets/sts-chrome.js, which asks STS.cartHold first.
   4. "Added to cart" with View cart (Luis 2026-10-13): the dot alone read as
      nothing happening. Same trigger as the dot, so every add that raises
      the count says it: the PDP buy box and sticky bar, quick-add on a card,
      Start my routine on the results page. */
(function () {
  'use strict';
  var w = window;
  var d = document;
  var STS = w.STS = w.STS || {};
  var mq = w.matchMedia ? w.matchMedia('(max-width: 860px)') : null;
  var calm = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var BACK = 'sts.cartBack';
  var SCROLL = 'sts.cartScroll';

  function phone() { return !!(mq && mq.matches && d.querySelector('[data-sts-bnav]')); }
  function strip(p) { return String(p || '').replace(/\/+$/, ''); }
  function cartPath() {
    var r = w.theme && w.theme.routes && w.theme.routes.cart;
    return strip(typeof r === 'string' && r ? r : '/cart');
  }
  function onCart() { return strip(w.location.pathname) === cartPath(); }
  function get(k) { try { return JSON.parse(w.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function put(k, v) { try { if (v) w.sessionStorage.setItem(k, JSON.stringify(v)); else w.sessionStorage.removeItem(k); } catch (e) { /* private mode */ } }

  /* ── 1. open the page, and come back ─────────────────────────────────── */

  /* Arriving on /cart from checkout is "no stored page". */
  if (onCart() && /\/checkouts?\b/.test(d.referrer || '')) put(BACK, null);

  function back() {
    var to = get(BACK);
    put(BACK, null);
    if (!to || !to.u) { w.location.assign((w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'); return; }
    if (d.referrer === to.u && w.history.length > 1) { w.history.back(); return; }
    put(SCROLL, to);
    w.location.assign(to.u);
  }

  w.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.sts-header__cart, [data-sts-bnav-cart], [data-sts-toast-cart]');
    if (!a || !phone() || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    /* The app's own listener (capture, on document) never sees it. */
    e.stopPropagation();
    /* A script "opening the drawer" after an add (STSRoutine.cart.openDrawer):
       on a phone the dot says it instead. */
    if (!e.isTrusted) { e.preventDefault(); return; }
    if (onCart()) { e.preventDefault(); back(); return; }
    put(BACK, { u: w.location.href, y: w.scrollY || 0 });
  }, true);

  /* Landing back on the page the cart was opened from, when history could not
     take us there itself. */
  var at = get(SCROLL);
  if (at && at.u === w.location.href) {
    put(SCROLL, null);
    var go = function () { w.scrollTo(0, at.y || 0); };
    go();
    w.addEventListener('load', function () { go(); w.setTimeout(go, 300); });
  }

  /* ── 2. no drawer on a phone ─────────────────────────────────────────── */

  ['lcu:cart:toggle', 'lca_regal_upsells:drawer:toggle'].forEach(function (name) {
    w.addEventListener(name, function (e) {
      if (!phone() || (e.detail && e.detail.open === false)) return;
      e.stopImmediatePropagation();
    }, true);
  });

  /* ── 3. the dot ──────────────────────────────────────────────────────── */

  var tap = null;
  d.addEventListener('pointerdown', function (e) { tap = { x: e.clientX, y: e.clientY, t: Date.now() }; }, true);

  var flying = false;
  var next = 0;

  function paint(n) {
    if (STS.chrome && STS.chrome.paintCount) STS.chrome.paintCount(n);
  }

  function land(icon) {
    flying = false;
    paint(next);
    if (!icon.animate) return;
    icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(1)' }], { duration: 280, easing: 'ease-out' });
    var badge = icon.querySelector('[data-cart-count]');
    if (badge && badge.animate) {
      badge.animate([
        { transform: 'scale(.3)', opacity: 0 },
        { transform: 'scale(1.25)', opacity: 1, offset: 0.6 },
        { transform: 'scale(1)', opacity: 1 }
      ], { duration: 320, easing: 'ease-out' });
    }
  }

  /* ── 4. the toast ────────────────────────────────────────────────────
     STS.ui.toast (assets/sts-popups.js): role=status, 4s, held while touched
     or focused. It sits 12px above the highest thing fixed to the bottom of
     the screen (the menu, the PDP sticky bar or its pill, the results page's
     Start my routine bar), measured while it shows: the PDP bar slides in and
     out with the scroll. sts:cart:updated and theme:cart:change both arrive
     for one add, and the badge keeps the old number while the dot flies, so
     `told` is the count already announced. */
  var BARS = '[data-sts-bnav],[data-sts-sticky][data-shown="true"],[data-sts-sticky-min]:not([hidden]),[data-slq-sticky-bar]';
  var told = -1;
  var host = null;

  function live() { return !!(host && host.querySelector('.sts-toast:not(.is-closing)')); }
  function lift() {
    if (!host) return;
    if (!live()) { host.style.bottom = ''; return; }
    var h = w.innerHeight, top = h;
    Array.prototype.forEach.call(d.querySelectorAll(BARS), function (el) {
      var r = el.getBoundingClientRect();
      if (r.height && r.top < top && r.top > h / 3 && w.getComputedStyle(el).visibility !== 'hidden') top = r.top;
    });
    host.style.bottom = (h - top + 12) + 'px';
  }
  function added() {
    var ui = STS.ui;
    if (!ui || !ui.toast) return;
    ui.toast('Added to cart', { duration: 4000, action: { label: 'View cart', href: cartPath(), data: 'sts-toast-cart' } });
    host = d.querySelector('.sts-toasts');
    lift();
    w.setTimeout(lift, 350);
  }
  w.addEventListener('scroll', lift, { passive: true });
  w.addEventListener('resize', lift);

  /* true = "I will paint it when the dot lands". */
  STS.cartHold = function (n) {
    var icon = d.querySelector('[data-sts-bnav] [data-sts-cart-icon]');
    var badge = icon && icon.querySelector('[data-cart-count]');
    var was = badge ? parseInt(badge.getAttribute('data-cart-count'), 10) || 0 : n;
    if (n <= was) told = -1;
    else if (n !== told && phone() && !onCart()) { told = n; added(); }
    if (flying) { next = n; return true; }
    if (!badge || !phone() || onCart() || n <= was || (calm && calm.matches)) return false;
    var dot = d.createElement('div');
    if (!dot.animate) return false;
    flying = true;
    next = n;

    var t = icon.getBoundingClientRect();
    var p = tap && Date.now() - tap.t < 5000 ? tap : { x: w.innerWidth / 2, y: w.innerHeight / 2 };
    var x0 = p.x - 8, y0 = p.y - 8;
    var x1 = t.left + t.width / 2 - 8, y1 = t.top + t.height / 2 - 8;
    var peak = Math.min(y0, y1) - 70;
    dot.className = 'sts-cart-dot';
    dot.setAttribute('aria-hidden', 'true');
    d.body.appendChild(dot);
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (dot.parentNode) dot.parentNode.removeChild(dot);
      land(icon);
    }
    var anim = dot.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + (x0 + (x1 - x0) * 0.45) + 'px,' + peak + 'px) scale(1.1)', opacity: 1, offset: 0.4 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.55)', opacity: 0.9 }
    ], { duration: 620, easing: 'cubic-bezier(.45,0,.7,1)', fill: 'forwards' });
    anim.onfinish = finish;
    /* A hidden tab can hold an animation; the number must still arrive. */
    w.setTimeout(finish, 1500);
    return true;
  };
})();
